import { render, staticRenderFns } from "./SuccessScreen.vue?vue&type=template&id=5a7d828a&scoped=true&"
import script from "./SuccessScreen.vue?vue&type=script&lang=js&"
export * from "./SuccessScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d828a",
  null
  
)

export default component.exports